import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function LoadingSpinner({ button, label }: {
  button?: JSX.Element,
  label?: string;
}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: '100px', margin: [0, 'auto'] }}>
      <CircularProgress color="success" sx={{ margin: [0, 'auto'] }}/>
      {label && <span>{label}</span>}
      {button || null}
    </Box>
  );
}